<script setup lang="ts">
  import SvgIcon from '@/components/common/icon/SvgIcon.vue';
  import type { BookIconName } from '@/constants/svg';

  withDefaults(
    defineProps<{
      name: BookIconName;
      /** 图标边长，侧边翻页箭头设计稿为 28 */
      size?: number | string;
    }>(),
    {
      size: 16
    }
  );
</script>

<template>
  <SvgIcon class="book-control-icon" :name="name" :size="size" />
</template>

<style scoped>
  .book-control-icon {
    display: block;
    flex-shrink: 0;
    stroke: currentColor;
  }
</style>
